@if (serviceRequired) {
  <span [title]="title" class="text-muted">
    <span class="fa fa-fw fa-ship"></span>
    <span class="badge rounded-pill text-bg-secondary align-top me-1"
          style="font-size: 0.6em;">{{ tugBoatQuantity | requiredQuantity }}</span>
    {{ service.serviceProvider?.name }}
  </span>
}
